export default __webpack_public_path__ + "static/media/nd.3541d50f.png";